import React, { Component } from 'react';
import './Loading.css';

class Loading extends Component {
	render(){
		let letters = ['A', 'N', 'A', 'L', 'Y', 'Z', 'I', 'N', 'G'];

		let loadingLetters = letters.map((l, index) => {
			return(
				<span id={`letter-${index}`} style={{animationDelay: `${0.2*index}s`}} key={index}>{l}</span>
				)
		})

		return(
			<div className="container loading-screen">
			{loadingLetters}
			</div>
			)
	}
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js